import React from "react"
import { motion } from "framer-motion"
import { AnimatePresence } from "framer-motion"
import { failXTime } from "./Constants"
let failXTimer

const FailX = ({ wrong, giveUp }) => {
	const [showFailX, setShowFailX] = React.useState(0)

	// Show FailX
	React.useEffect(() => {
		if (wrong > 0) {
			setShowFailX((showFailX) => showFailX + 1)
		}
	}, [wrong])

	// Show/hide Failx
	React.useEffect(() => {
		if (showFailX > 0) {
			clearTimeout(failXTimer)
			failXTimer = setTimeout(() => setShowFailX(0), failXTime)
		}
		return () => clearTimeout(failXTimer)
	}, [showFailX])

	const Xs = []
	for (let i = 0; i < wrong; i++) {
		Xs.push(
			<motion.div
				key={`x${i}`}
				exit={{ top: "150px", opacity: 0, transition: { type: "tween" } }}
				animate={{ top: "0px" }}
				transition={{
					type: "spring",
					duration: 0.75,
					bounce: 0.8,
				}}
				initial={{ top: "-200px" }}
				style={{
					flex: 1,
					fontFamily: "Permanent Marker",
					fontSize: "23vw",
					color: "var(--red)",
					margin: "0 var(--half)",
					position: "relative",
				}}>
				X
			</motion.div>
		)
	}
	return (
		<AnimatePresence>
			{showFailX && !giveUp && (
				<div
					style={{
						position: "absolute",
						width: "100%",
						zIndex: 99,
						pointerEvents: "none",
						display: "flex",
						justifyContent: "space-evenly",
						marginTop: "calc(-1 * var(--quarter))",
					}}>
					<div
						id="FailXWrapper"
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							width: "100%",
							maxWidth: "1000px",
						}}>
						{Xs}
					</div>
				</div>
			)}
		</AnimatePresence>
	)
}
export default FailX
